import JobSalaryRange from ".";

export const jobSalaryRangeRoutes = () => [
  {
    path: "/admin/job-salaryRange",
    component: JobSalaryRange,
    layout: "admin",
    routeType: "admin",
    title: "Jobs Management",
  },
];
